import React from "react";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import {
  BrowserRouter as Router,
  Route,
  Link,
  withRouter,
} from "react-router-dom";
import AllPagesPDFViewer from "../pdf/allpages_pdfviewer";
import GeneralBloc from "../../../bloc/general_bloc";
import "./terms_and_condition_dialog.css";
import AppGroupButtonDialog from "../app_group_button_dialog/app_group_button_dialog";
import AppMainButton from "../app_main_button/app_main_button";
import LanguageBloc from "../../../bloc/language_bloc";
import Labels from "../../constant/labels";
import AppTransparentButton from "../app_transparent_button/app_transparent_button";

class TermsAndConditionDialog extends React.Component {
  //props:title, description, buttonLabel
  constructor(props) {
    super(props);
    this.state = {
      mobilesize: false,
    };

    this.updateDimensions = this.updateDimensions.bind(this);
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);
    this.updateDimensions();
  }

  propPositiveButtonLabel() {
    return (
      this.props.propPositiveButtonLabel ||
      LanguageBloc.getTextByCode(Labels.LBL_AGREE)
    );
  }

  updateDimensions = () => {
    //console.log('TNC Dialog : Inner width = ' + window.innerWidth);
    if (window.innerWidth <= 425) {
      this.setState({ mobilesize: true });
    } else {
      this.setState({ mobilesize: false });
    }
  };

  closeDialog = () => {
    this.props.onDialogClose();
  };

  viewPDF() {
    return (
      <div className="col-md-12 text-left" style={{ height: "100%" }}>
        {this.props.showClose && (
          <div className="text-right">
            <img
              src={`${GeneralBloc.getAssetsContextPath()}/assets/images/Clear_Icon.svg`}
              className="terms_and_condition_close_button"
              onClick={() => this.closeDialog()}
              alt="Close"
            />
          </div>
        )}

        <div className="d-flex justify-content-end mb-2">
          {this.props.showPrint && (
            <AppTransparentButton
              label={LanguageBloc.getTextByCode(Labels.LBL_PRINT)}
              enable={this.props.enable}
              onClick={() => this.props.printPDF?.()}
              buttonWidth="140px"
            />
          )}
          {this.props.showDownload && (
            <div className="ml-2">
              <AppTransparentButton
                label={"Download / <i><strong>Muat Turun</strong></i>"}
                enable={this.props.enable}
                onClick={() => this.props.downloadPDF?.()}
              />
            </div>
          )}
        </div>
        
        <div className={`${this.props.showPrint==true ? "pdf_viewer_container_with_print":"pdf_viewer_container"} noselect`}>
          <div className="noselect" style={{ height: "100%" }}>
            <AllPagesPDFViewer
              pdf={this.props.content}
              mobile={this.state.mobilesize}
              width={window.innerWidth}
              height={window.innerHeight}              
              onClose={() => {
                this.closeDialog()
              } }
            />
          </div>
        </div>

        {/* {this.props.showClose && (
          <div className="text-right mt-4">
            <AppTransparentButton
              label={LanguageBloc.getTextByCode(Labels.LBL_CLOSE)}
              enable={this.props.enable}
              onClick={() => this.closeDialog()}
              buttonWidth="140px"
            />
          </div>
        )} */}
      </div>
    );
}

  viewImage() {
    return (
      <div className="col-md-12 text-left">
        {this.props.showClose == true && (
          <div style={{ "text-align": "right" }}>
            <div>
              <img
                src={
                  GeneralBloc.getAssetsContextPath() +
                  "/assets/images/Clear_Icon.svg"
                }
                className="terms_and_condition_close_button"
                onClick={() => this.closeDialog()}
              />
            </div>
          </div>
        )}
        <div className="w-100 text-center align-items-center" >
          <img
            className="img-fluid image_view"
            style={{
              maxHeight:"500px"
            }}
            src={this.props.content}
          />
        </div>

      </div>
    );
  }

  render() {
    const noPadding = {
      padding: "0px",
      margin: "0px",
      maxHeight: "531px",
    };

    const modalHeight = {
      height: this.state.mobilesize
        ? "100%"
        : this.props.type == "pdf"
          ? "90vh"
          : "80vh",
    };

    var btnLabel = this.props.buttonLabel;

    return <div>
      {
        this.props.type != "pdf" && !this.state.mobilesize ?
          <Modal
            className="modal-termcondition"
            backdrop="static"
            style={{ maxWidth: "600px", width: "80%" }}
            centered
            isOpen={this.props.isOpen}
          >
            <ModalBody style={modalHeight}>
              <div className="row terms-modal-content">
                {this.viewImage()}
              </div>
            </ModalBody>

            <ModalFooter>
              {
                !this.props.showPositiveButton == true ? null : <AppMainButton
                  label={this.propPositiveButtonLabel()}
                  enable={true}
                  onClick={() => this.closeDialog()}
                  icon={false}
                  buttonWidth={"200px"}
                />
              }

            </ModalFooter>

          </Modal>
          :
          <Modal
            className="modal-termcondition"
            backdrop="static"
            size="xl"
            style={{ width: "100%", marginTop: 12 }}
            // style={{ maxWidth: "1300px", width: "80%" }}
            centered
            isOpen={this.props.isOpen}
          >
            <ModalBody style={modalHeight}>
              <div className="row terms-modal-content">
                {this.props.type == "pdf" ? this.viewPDF() : this.viewImage()}
              </div>
            </ModalBody>

            <ModalFooter>
              {
                !this.props.showPositiveButton == true ? null : <AppMainButton
                  label={this.propPositiveButtonLabel()}
                  enable={true}
                  onClick={() => this.closeDialog()}
                  icon={false}
                  buttonWidth={"200px"}
                />
              }
            </ModalFooter>

          </Modal>
      }

    </div>;
  }
}

export default withRouter(TermsAndConditionDialog);
